function Footer() {
  return <footer className="footer-layout">
    &copy; 2023 PT. Pasmaritim Samudera Nusantara
  </footer>;
}

export default Footer;
